module.exports = __webpack_public_path__ + "static/media/lights_focused@2x.13158f4a.png";